import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class AmsHouseListItem extends AmsListItemBase {
    id: string = '';
    amsStatus: string = '';
    userId: string = '';
    subUserId: string = '';
    strBlock: string = '';
    block: boolean|null = null;
    branch: string = '';
    vSendDate: string | null = null;
    fromVSendDate: string | null = null;
    toVSendDate: string | null = null;
    status: string = '';
    responseCode: string = '';
    hblNo: string = '';
    vInbondNo: string = '';
    mblNo: string = '';
    coLoadAms: boolean|null = null;
    coLoadAmsbl: string = '';
    responseDate: string | null = null;
    fromResponseDate: string | null = null;
    toResponseDate: string | null = null;
    statusRemark: string = '';
    sName: string = '';
    cName: string = '';
    nName: string = '';
    manifestSeq: string = '';
    vesselName: string = '';
    voyage: string = '';
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    loadPort: string = '';
    dCode: string = '';
    moveType: string = '';
    amsMasterId: number = 0;
    loadEtd: string | null = null;
    fromLoadEtd: string | null = null;
    toLoadEtd: string | null = null;
    onBoard: string | null = null;
    fromOnBoard: string | null = null;
    toOnBoard: string | null = null;
    amsUserId: number|null = null;
    amsVoyageId: number|null = null;
    amsGroupId: number|null = null;
    createAt: string|null = null;
    fromCreateAt: string|null = null;
    toCreateAt: string|null = null;
    updateAt: string|null = null;
    fromUpdateAt: string|null = null;
    toUpdateAt: string|null = null;
    ipAddress: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'stat', hiddenInColumnSetup: true, filterable: false }),
        //XCol.Create({ col: 1, text: 'AMS ID', width: 80, dataIndex: 'id', align: XCol.XAlignType.Right, hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Manifest #', width: 100, dataIndex: 'manifestSeq'}),
        XCol.Create({ col: 2, text: 'S', width: 40, dataIndex: 'amsStatus', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'User', width: 100, dataIndex: 'userId'}),
        XCol.Create({ col: 4, text: 'Sub User', width: 100, dataIndex: 'subUserId'}),
        XCol.Create({ col: 5, text: 'Download', width: 60, dataIndex: 'block', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 6, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 7, text: 'Send Date', width: 75, dataIndex: 'vSendDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: ' HH:mm'}),
        XCol.Create({ col: 8, text: 'Error Status', width: 100, dataIndex: 'status'}),
        XCol.Create({ col: 9, text: 'DP', width: 60, dataIndex: 'responseCode', align: XCol.XAlignType.Center}),

        XCol.Create({ col: 10, text: 'HBL #', width: 100, dataIndex: 'hblNo', defaultColumnFocus : true}),
        XCol.Create({ col: 11, text: 'MBL #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 12, text: 'Vessel Name', width: 120, dataIndex: 'vesselName'}),
        XCol.Create({ col: 13, text: 'Voyage #', width: 80, dataIndex: 'voyage'}),
        XCol.Create({ col: 14, text: 'Co-Load', width: 60, dataIndex: 'coLoadAms', type: XCol.XCellType.Bool, noNullOrEmptySearch: true}),
        // XCol.Create({ col: 14, text: 'Co-Load B/L', width: 120, dataIndex: 'coLoadAmsbl'}),
        XCol.Create({ col: 15, text: 'Response', width: 75, dataIndex: 'responseDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: ' HH:mm'}),
        XCol.Create({ col: 16, text: 'Status', width: 120, dataIndex: 'statusRemark'}),
        XCol.Create({ col: 17, text: 'Shipper', width: 120, dataIndex: 'sName'}),
        XCol.Create({ col: 18, text: 'Consignee', width: 120, dataIndex: 'cName'}),
        XCol.Create({ col: 19, text: 'Notify', width: 120, dataIndex: 'nName'}),
        XCol.Create({ col: 20, text: 'Loading', width: 60, dataIndex: 'loadPort'}),
        XCol.Create({ col: 21, text: 'Discharge', width: 60, dataIndex: 'dCode'}),
        XCol.Create({ col: 22, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 23, text: 'ETD', width: 75, dataIndex: 'loadEtd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 24, text: 'H. Move Type', width: 80, dataIndex: 'moveType'}),
        XCol.Create({ col: 25, text: 'Onboard', width: 75, dataIndex: 'onBoard', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 26, text: 'Create Date', width: 100, dataIndex: 'createAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, }),
        XCol.Create({ col: 27, text: 'Update Date', width: 100, dataIndex: 'updateAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 28, text: 'IP Address', width: 110, dataIndex: 'ipAddress'})
    ];


    public static getExportCollection(useBranch: boolean, isSuntekAdmin: boolean = false): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        if (!isSuntekAdmin) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'ipAddress');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: AmsHouseListItem.prototype.id, orderByAscending: false };

    public static formatData(data: AmsHouseListItem[]) {
        return data.map((d: AmsHouseListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        responseDate: {from: 'fromResponseDate', to: 'toResponseDate'},
        eta: {from: 'fromEta', to: 'toEta'},
        loadEtd: {from: 'fromLoadEtd', to: 'toLoadEtd'},
        onBoard: {from: 'fromOnBoard', to: 'toOnBoard'},
        createAt: {from: 'fromCreateAt', to:'toCreateAt'},
        updateAt: {from: 'fromUpdateAt', to: 'toUpdateAt'}
    }
}
